import { render, staticRenderFns } from "./OrderImportExcel.vue?vue&type=template&id=6b8d2982"
import script from "./OrderImportExcel.vue?vue&type=script&lang=js"
export * from "./OrderImportExcel.vue?vue&type=script&lang=js"
import style0 from "./OrderImportExcel.vue?vue&type=style&index=0&id=6b8d2982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports